<template>
  <select
    :value="value"
    @input="$emit('input', $event.target.value)"
    class="select-input"
    :class="{ active: !!value }"
  >
    <option v-if="placeholder" disabled value="">{{ placeholder }}</option>
    <option
      v-for="{ value, label } in selectOptions"
      :key="value"
      :value="value"
    >
      {{ label }}
    </option>
  </select>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    selectOptions() {
      return this.options
        .map(item => {
          if (typeof item === 'object' && 'value' in item && 'label' in item) {
            return item;
          }
          if (typeof item === 'string') {
            return { value: item, label: item };
          }
          return null;
        })
        .filter(item => item);
    },
  },
};
</script>

<style lang="scss" scoped>
.select-input {
  appearance: none;
  background-color: var(--light-dim-blue);
  border-radius: 10px;
  color: var(--white);
  font-size: 24px;
  font-style: italic;
  line-height: 28px;
  padding: 22px 20px;

  &.active {
    background-color: var(--white);
    color: var(--black);
    font-style: normal;
  }
}
</style>
